function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShowPassword = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.618,0.397C12.41,0.397 9.041,2.314 6.588,4.595C4.151,6.855 2.521,9.563 1.75,11.422C1.578,11.834 1.578,12.292 1.75,12.703C2.521,14.562 4.151,17.271 6.588,19.531C9.041,21.812 12.41,23.728 16.618,23.728C20.826,23.728 24.196,21.812 26.649,19.531C29.086,17.265 30.716,14.562 31.492,12.703C31.664,12.292 31.664,11.834 31.492,11.422C30.716,9.563 29.086,6.855 26.649,4.595C24.196,2.314 20.826,0.397 16.618,0.397ZM24.118,12.063C24.118,16.203 20.759,19.562 16.618,19.562C12.478,19.562 9.119,16.203 9.119,12.063C9.119,7.922 12.478,4.563 16.618,4.563C20.759,4.563 24.118,7.922 24.118,12.063ZM16.618,8.73C16.618,10.568 15.124,12.063 13.285,12.063C12.686,12.063 12.124,11.906 11.64,11.625C11.629,11.771 11.619,11.912 11.619,12.063C11.619,14.823 13.858,17.062 16.618,17.062C19.379,17.062 21.618,14.823 21.618,12.063C21.618,9.303 19.379,7.063 16.618,7.063C16.473,7.063 16.327,7.068 16.181,7.084C16.457,7.568 16.618,8.131 16.618,8.73Z",
    style: {
      fill: "#ccc",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShowPassword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/show-password.2347ed0cdfea1cb2112e4a460ea7161c.svg";